// Parent authentication state derived from the auth slice.
import { createSelector } from 'reselect';

const currentUserId = (state: any) => state.auth?.currentUserId;
const signupCompleted = (state: any) => state.auth?.signupCompleted;

// The single definition of "this parent may see a private route". Every route
// guard reads this rather than re-deriving `currentUserId && signupCompleted`,
// so a parent mid-signup is treated the same way everywhere.
export const selectParentIsAuthenticated = createSelector(
  [currentUserId, signupCompleted],
  (userId, completed): boolean => Boolean(userId) && Boolean(completed),
);

// The CSS/brand identifier for the current studio. Route guards pass it to
// /login-redirect, which is why it is read here rather than threaded down from
// App's server-rendered props.
export const selectCompanyName = (state: any): string =>
  state.company?.name || '';
